/** Closed vocabulary for model arguments and editorial catalogue metadata. */
export const KNOWLEDGE_TAGS = [
    "solve",
    "vsm",
    "hoshin",
    "lama",
    "player-ai",
    "platform",
    "admin",
    "framework",
    "software",
    "workshop",
    "practice",
    "reference",
    "problem-statement",
    "run-chart",
    "containment",
    "root-cause",
    "pareto",
    "fishbone",
    "five-whys",
    "countermeasures",
    "standard-work",
    "canvas",
    "access",
    "reporting",
    "coaching",
    "value-stream",
    "sipoc",
    "current-state",
    "future-state",
    "kaizen",
    "strategy",
    "x-matrix",
    "catchball",
    "measures",
    "ideation",
    "prioritization",
    "assessment",
    "evidence",
    "questionnaires",
    "campaigns",
    "notifications",
    "preferences",
    "teams",
    "integrations",
    "identity",
    "email",
    "ai-configuration",
    "audit",
    "adoption",
];
/** Curated topics, keyed by stable guide ID; domains/sections are added below. */
export const KNOWLEDGE_ARTICLE_TOPIC_TAGS = {
    "solve-what-it-is": ["problem-statement", "evidence"],
    "solve-five-steps": [
        "problem-statement",
        "root-cause",
        "countermeasures",
        "standard-work",
    ],
    "solve-tags": ["problem-statement", "measures"],
    "solve-run-chart": ["run-chart", "measures"],
    "solve-containment": ["containment"],
    "solve-gemba-chain": ["root-cause", "evidence"],
    "solve-pareto": ["root-cause", "pareto"],
    "solve-fishbone": ["root-cause", "fishbone"],
    "solve-five-whys": ["root-cause", "five-whys"],
    "solve-verify": ["countermeasures"],
    "solve-ensure": ["standard-work"],
    "solve-create": ["problem-statement"],
    "solve-flexible-widgets": ["canvas"],
    "solve-specify-widgets": ["canvas", "problem-statement", "run-chart"],
    "solve-oppress-widgets": ["canvas", "containment"],
    "solve-look-widgets": [
        "canvas",
        "root-cause",
        "pareto",
        "fishbone",
        "five-whys",
    ],
    "solve-verify-widgets": ["canvas", "countermeasures"],
    "solve-ensure-widgets": ["canvas", "standard-work"],
    "solve-people-settings": ["access"],
    "solve-history-export-complete": ["reporting", "audit"],
    "solve-workshop": ["coaching", "problem-statement", "root-cause"],
    "solve-coaching": ["coaching"],
    "solve-practice": ["problem-statement", "root-cause", "evidence"],
    "solve-practice-real": ["problem-statement", "evidence"],
    "solve-reference": ["problem-statement", "root-cause", "countermeasures"],
    "vsm-see-the-whole-flow": ["value-stream"],
    "vsm-scope-family-and-sipoc": ["value-stream", "sipoc"],
    "vsm-flow-terms": ["value-stream", "measures"],
    "vsm-preparation-in-the-software": ["sipoc", "access"],
    "vsm-current-state-build-guide": ["current-state", "canvas", "value-stream"],
    "vsm-read-vsm-arrows": ["current-state", "future-state", "value-stream"],
    "vsm-current-to-future-state": [
        "current-state",
        "future-state",
        "value-stream",
    ],
    "vsm-prioritise-vsm-improvements": ["kaizen", "prioritization"],
    "vsm-implementation-and-control": ["kaizen", "measures"],
    "vsm-vsm-people-settings-and-history": ["access", "audit"],
    "vsm-facilitate-a-vsm-event": ["coaching", "value-stream", "sipoc"],
    "vsm-run-a-vsm-workshop": [
        "coaching",
        "value-stream",
        "current-state",
        "future-state",
    ],
    "vsm-practice-an-access-request-stream": [
        "current-state",
        "future-state",
        "value-stream",
    ],
    "hoshin-strategy-that-deploys": ["strategy", "x-matrix", "catchball"],
    "hoshin-x-matrix-and-catchball": ["x-matrix", "catchball", "strategy"],
    "hoshin-tti-kpi-and-monthly-targets": ["measures", "strategy"],
    "hoshin-create-plan-and-cascade": ["strategy", "access"],
    "hoshin-ideate-present-and-group": ["ideation", "strategy"],
    "hoshin-vote-and-prioritize": ["prioritization", "strategy"],
    "hoshin-build-x-matrix-and-add-tti": ["x-matrix", "measures", "strategy"],
    "hoshin-track-targets-and-linked-work": ["measures", "reporting", "strategy"],
    "hoshin-hoshin-people-settings-and-history": ["access", "audit"],
    "hoshin-seven-step-planning-workshop": [
        "x-matrix",
        "catchball",
        "strategy",
        "coaching",
    ],
    "hoshin-strategy-review-reference": ["measures", "reporting", "strategy"],
    "hoshin-practice-a-service-strategy": ["strategy", "x-matrix", "measures"],
    "lama-a-mirror-not-an-audit": ["assessment", "evidence"],
    "lama-the-assessment-cycle": ["assessment", "campaigns"],
    "lama-build-and-publish-a-questionnaire": ["assessment", "questionnaires"],
    "lama-write-and-review-questions": [
        "assessment",
        "questionnaires",
        "evidence",
    ],
    "lama-set-up-a-campaign": ["campaigns", "access"],
    "lama-open-monitor-and-close-waves": ["campaigns", "assessment"],
    "lama-complete-your-assessment": ["assessment", "evidence"],
    "lama-record-and-correct-a-baseline": ["assessment", "evidence"],
    "lama-read-share-and-export-reports": ["reporting", "access"],
    "lama-hold-an-honest-assessment-conversation": [
        "assessment",
        "evidence",
        "coaching",
    ],
    "lama-practice-evidence-and-calibration": ["assessment", "evidence"],
    "lama-maturity-terms": ["assessment", "evidence"],
    "player-ai-what-player-ai-is": ["coaching"],
    "player-ai-execution-and-capability": ["coaching", "evidence"],
    "player-ai-trust-and-agency": ["access", "evidence"],
    "player-ai-participant-and-facilitator-guide": ["preferences", "coaching"],
    "platform-make-home-useful": ["preferences"],
    "platform-open-tabs-and-find-work": ["preferences"],
    "platform-work-together-and-read-history": ["access", "audit"],
    "platform-manage-notifications": ["notifications", "preferences"],
    "platform-set-account-and-launcher-preferences": ["preferences"],
    "platform-create-and-join-teams": ["teams", "access"],
    "platform-connect-your-accounts": ["integrations", "access"],
    "platform-manage-kpis-and-record-values": ["measures"],
    "admin-find-your-way": ["access"],
    "admin-add-people": ["access", "identity"],
    "admin-change-roles": ["access", "identity"],
    "admin-access-passwords-sessions": ["access", "identity"],
    "admin-identity-status": ["identity"],
    "admin-scim-provisioning": ["identity"],
    "admin-directory-groups-teams": ["identity", "teams", "access"],
    "admin-organization-profile": ["preferences"],
    "admin-module-availability": ["access"],
    "admin-mail-server": ["email"],
    "admin-notification-templates": ["email", "notifications"],
    "admin-email-delivery": ["email", "notifications"],
    "admin-ai-connections": ["ai-configuration"],
    "admin-ai-profiles-defaults": ["ai-configuration", "preferences"],
    "admin-integration-setup": ["integrations", "access"],
    "admin-integration-tool-access": ["integrations", "access"],
    "admin-adoption-tours": ["adoption", "reporting"],
    "admin-audit-history": ["audit", "reporting"],
};
/** Check membership in the controlled topic, domain and activity tag vocabulary. */
export function isKnowledgeTag(value) {
    return KNOWLEDGE_TAGS.includes(value);
}
/** Validate at most eight tags, normalize their case, and remove duplicates. */
export function normalizeKnowledgeTags(tags) {
    if (tags.length > 8)
        throw new RangeError("Supply at most 8 Knowledge Studio tags.");
    return [
        ...new Set(tags.map((tag) => {
            const normalized = tag.trim().toLowerCase();
            if (!isKnowledgeTag(normalized)) {
                throw new TypeError(`Unsupported Knowledge Studio tag: ${tag}`);
            }
            return normalized;
        })),
    ];
}
/** Combine domain, section and canonical topic tags without duplicates. */
export function knowledgeArticleTags(article) {
    return [
        ...new Set([
            article.domainId,
            article.section,
            ...(article.tags ?? KNOWLEDGE_ARTICLE_TOPIC_TAGS[article.id] ?? []),
        ]),
    ];
}
//# sourceMappingURL=tags.js.map